module.exports = __webpack_public_path__ + "img/PriceQuotations_WorkProgress.d24a2d54.svg";